// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__12Ff2","info":"UpdateTermsInfo_info__lBQNM"};